export default {
  namespaced: true,
  state: () => {
    return {
      fileName: '',
      fileSize: '',
      hash: '',
      razonSocial: '',
      rfc: ''
    }
  },
  mutations: {
    SET_FILE_NAME(state, fileName) {
      state.fileName = fileName
    },
    SET_FILE_SIZE(state, fileSize) {
      state.fileSize = fileSize
    },
    SET_HASH(state, hash) {
      state.hash = hash
    },
    SET_RAZON_SOCIAL(state, razonSocial) {
      state.razonSocial = razonSocial
    },
    SET_RFC(state, rfc) {
      state.rfc = rfc
    }
  },
  actions: {
    setDataReview({ commit }, data) {
      if(data.fileName != undefined){
        commit('SET_FILE_NAME', data.fileName)
      }
      if(data.fileSize != undefined){
        commit('SET_FILE_SIZE', data.fileSize)
      }
      if(data.hash != undefined){
        commit('SET_HASH', data.hash)
      }
      if(data.razonSocial != undefined){
        commit('SET_RAZON_SOCIAL', data.razonSocial)
      }
      if(data.rfc != undefined){
        commit('SET_RFC', data.rfc)
      }
    }
  },
  getters:{
    reviewFileName(state) {
      return state.fileName
    },
    reviewFileSize(state) {
      return state.fileSize
    },
    reviewHash(state) {
      return state.hash
    },
    reviewRazonSocial(state) {
      return state.razonSocial
    },
    reviewRFC(state) {
      return state.rfc
    }
  }
}